import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";

const PageLayout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Automatically close the menu when the screen size is >= sm
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 640) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex flex-col sm:flex-row w-full max-w-[52rem] h-full mx-auto">
      {/* Navbar Section */}
      <div
        className={`sm:w-[25%] sm:2xl:w-[14rem] ${
          isMenuOpen ? "paper-soft absolute top-0 left-0 w-full h-full z-20" : "hidden"
        } sm:block`}
      >
        {/* Close Button for Hamburger Menu (only visible below sm) */}
        {isMenuOpen && (
          <button
            className="absolute top-4 right-4 text-[2.5rem] font-bold hover:text-[#1a1a1a] transition-colors duration-200 sm:hidden"
            onClick={() => setIsMenuOpen(false)}
          >
            ✕
          </button>
        )}

        <Navbar />
      </div>

      {/* Hamburger Menu Button (Visible below sm) */}
      <div className="sm:hidden border-b-[0.11rem] flex items-center justify-end px-2 pb-2">
        <button
          className="text-[2.25rem] font-bold hover:text-[#1a1a1a] transition-colors duration-200"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>
      </div>

      {/* Content Section */}
      <div
        className={`w-full sm:w-[75%] pt-[0.4rem] pb-10 pl-6 pr-6 overflow-auto ${
          isMenuOpen && "hidden sm:block"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default PageLayout;
